import { AchievementFormValues } from 'types';

import { achievementsColors } from '../../constants/index';

export const defaultValues: AchievementFormValues = {
  title: '',
  description: '',
  color: achievementsColors[0],
};
